const swiperInstances = new WeakMap();
const thumbSwiperInstances = new WeakMap();

function getProductDataFromSwatchInput(input) {
    if (!input) return null;
    const dataScriptId = input.dataset.productDataId;
    const swatchItem = input.closest('.nw-featured-product__swatches-item');
    const dataScript = dataScriptId ? document.getElementById(dataScriptId) : swatchItem?.querySelector('[data-product-data]');
    if (!dataScript) return null;
    try { return JSON.parse(dataScript.textContent); } catch { return null; }
}

const SWATCH_INPUT_SELECTOR = 'input[name="nw-featured-product-swatches"]';

function getSwatchInput(swatchItem) { return swatchItem?.querySelector(SWATCH_INPUT_SELECTOR) || null; }
function getSwatchInputByProductId(context, productId) { if (!context || !productId) return null; return context.querySelector(`${SWATCH_INPUT_SELECTOR}[data-product-id="${productId}"]`); }
function getFirstRegularSwatchInput(context = getFeaturedProductContext()) { if (!context) return null; return context.querySelector(`.nw-featured-product__swatches-item:not([data-combo-swatch-item]) ${SWATCH_INPUT_SELECTOR}`); }
function getSwatchQuantity(swatchItem) { return parseInt(swatchItem?.querySelector('[data-swatch-quantity-input]')?.value, 10) || 0; }

function getActiveGalleryInput(context = getFeaturedProductContext()) {
    if (!context) return null;
    const activeProductId = context.dataset.activeGalleryProductId;
    if (activeProductId) { const a = getSwatchInputByProductId(context, activeProductId); if (a) return a; }
    const checked = context.querySelector(`${SWATCH_INPUT_SELECTOR}:checked`);
    return checked || getFirstRegularSwatchInput(context);
}

function showSwatchGallery(input, context = getFeaturedProductContext()) {
    const productId = input?.dataset?.productId;
    if (!input || !productId || !context) return;
    context.dataset.activeGalleryProductId = productId;
    showProductGallery(productId, context);
    updateBackgroundImage(input);
    updateColorScheme(input);
}

function getSellingPlansFromProductData(productData) { return productData?.selling_plans || []; }

function getSellingPlanFromProductDataByName(productData, planName) {
    const plans = getSellingPlansFromProductData(productData);
    const n = String(planName || '').trim().toLowerCase();
    if (!n) return null;
    return plans.find(p => String(p.name || '').trim().toLowerCase() === n) || null;
}

function getFeaturedProductContext(element) {
    return element?.closest('.nw-featured-product') || document.querySelector('.nw-featured-product');
}

/* === SINGLE-PRODUCT MODE ===
   When a buy box has exactly one regular (non-combo) product — e.g. a
   single-SKU landing page or product page — there is no “choose your coffee”
   decision to make, so Step 1 is redundant. These helpers detect that case;
   the init flow then auto-selects the product and opens directly at Step 2
   (plans). Multi-product buy boxes (the homepage) are unaffected. */
function getRegularSwatchItems(context = getFeaturedProductContext()) {
    if (!context) return [];
    return [...context.querySelectorAll('.nw-featured-product__swatches-item:not([data-combo-swatch-item])')];
}
function isSingleProductMode(context = getFeaturedProductContext()) {
    return getRegularSwatchItems(context).length === 1;
}

function setPurchaseMode(context, mode) { if (context) context.dataset.purchaseMode = mode; }
function isComboPurchaseMode(context = getFeaturedProductContext()) { return context?.dataset?.purchaseMode === 'combo'; }

function resetSwatchQuantities(context, exceptInput = null) {
    if (!context) return;
    context.querySelectorAll('[data-swatch-quantity-input]').forEach(i => { if (i !== exceptInput) i.value = 0; });
    updateSwatchActiveStates(context);
}

function clearComboSelection(context = getFeaturedProductContext()) {
    if (!context) return;
    context.querySelectorAll('[data-combo-swatch-item]').forEach(item => {
        const cb = getSwatchInput(item);
        const qi = item.querySelector('[data-swatch-quantity-input]');
        if (qi) qi.value = 0;
        if (cb) cb.checked = false;
        item.classList.remove('is-selected');
    });
}

function resetAllSwatchSelections(context = getFeaturedProductContext()) {
    if (!context) return;
    clearComboSelection(context);
    resetSwatchQuantities(context);
    context.querySelectorAll(SWATCH_INPUT_SELECTOR).forEach(i => { i.checked = false; });
    context.querySelectorAll('.nw-featured-product__swatches-item').forEach(i => i.classList.remove('is-selected'));
}

function selectSingleSwatchProduct(context, productId) {
    if (!context || !productId) return false;
    resetAllSwatchSelections(context);
    const cb = getSwatchInputByProductId(context, productId);
    if (!cb) return false;
    const swatchItem = cb.closest('.nw-featured-product__swatches-item');
    const qi = swatchItem?.querySelector('[data-swatch-quantity-input]');
    cb.checked = true;
    if (qi) qi.value = 1;
    setPurchaseMode(context, 'multi');
    handleSwatchChange(cb);
    return true;
}

function updateSwatchActiveStates(context = getFeaturedProductContext()) {
    if (!context) return;
    context.querySelectorAll('.nw-featured-product__swatches-item').forEach(item => {
        const cb = getSwatchInput(item);
        const qi = item.querySelector('[data-swatch-quantity-input]');
        const qty = parseInt(qi?.value, 10) || 0;
        const sel = qty >= 1;
        item.classList.toggle('is-selected', sel);
        if (cb) cb.checked = sel;
    });
    updateSwatchItemPrices(context);
}

function updateSwatchItemPrices(context = getFeaturedProductContext()) {
    if (!context) return;
    context.querySelectorAll('[data-swatch-price]').forEach(pc => {
        const swatchItem = pc.closest('.nw-featured-product__swatches-item');
        const qi = swatchItem?.querySelector('[data-swatch-quantity-input]');
        if (!qi) return;
        const unit = parseInt(pc.dataset.unitPrice, 10) || 0;
        const comp = parseInt(pc.dataset.compareUnitPrice, 10) || 0;
        const hasComp = pc.dataset.hasCompare === 'true';
        const mult = Math.max(parseInt(qi.value, 10) || 0, 1);
        const cur = pc.querySelector('[data-swatch-price-current]');
        const cmp = pc.querySelector('[data-swatch-price-compare]');
        if (cur) cur.textContent = formatMoney(unit * mult, cur);
        if (hasComp && cmp) cmp.textContent = formatMoney(comp * mult, cmp);
    });
}

function getAvailablePlanNamesForSelections(selections) {
    const names = new Set();
    if (!selections || !selections.length) return names;
    selections.forEach(s => {
        (s.productData?.selling_plans || []).forEach(p => {
            const name = String(p.name || '').trim();
            if (name) names.add(name.toLowerCase());
        });
    });
    return names;
}

function updatePlanVisibilityForMode(context = getFeaturedProductContext()) {
    if (!context) return;
    const isCombo = isComboPurchaseMode(context);
    const selections = getSelectedProductsWithQuantities(context);
    const availablePlanNames = getAvailablePlanNamesForSelections(selections);

    context.querySelectorAll('.nw-featured-product__plan-item').forEach(planItem => {
        const v = planItem.dataset.planVisibility || 'all';
        const inp = planItem.querySelector('.nw-featured-product__plan-item-input');
        const planName = (inp?.value || '').trim();
        let visible = true;
        if (v === 'regular_only' && isCombo) visible = false;
        if (v === 'combo_only' && !isCombo) visible = false;
        if (visible && availablePlanNames.size > 0 && planName) {
            if (!availablePlanNames.has(planName.toLowerCase())) visible = false;
        }
        planItem.classList.toggle('hidden', !visible);
        if (!visible && inp?.checked) inp.checked = false;
    });
    ensureSelectedPlanForMode(context);
}

function ensureSelectedPlanForMode(context = getFeaturedProductContext()) {
    if (!context) return;
    const visible = [...context.querySelectorAll('.nw-featured-product__plan-item:not(.hidden) .nw-featured-product__plan-item-input')];
    if (!visible.length) return;
    const checked = visible.find(i => i.checked);
    if (!checked) {
        const def = visible.find(i => i.dataset.defaultSelected === 'true') || visible[0];
        def.checked = true;
    }
    updatePlanSelectionState(context);
}

function getSellingPlanNameForCart(context = getFeaturedProductContext()) {
    const sel = context.querySelector('.nw-featured-product__plan-item:not(.hidden) input[name="nw-featured-product-plan"]:checked');
    return (sel?.value || sel?.dataset?.sellingPlanName || '').trim();
}

function getWelcomeKitCartItems(context = getFeaturedProductContext()) {
    const sel = context.querySelector('input[name="nw-featured-product-plan"]:checked');
    if (!sel) return [];
    const planItem = sel.closest('.nw-featured-product__plan-item');
    const ds = planItem?.querySelector('[data-plan-welcome-kit-products]');
    if (!ds) return [];
    try { const p = JSON.parse(ds.textContent); return p.filter(i => i?.variant_id).map(i => ({ id: parseInt(i.variant_id, 10), quantity: parseInt(i.quantity, 10) || 1 })); } catch { return []; }
}

function isOnSubscriptionStep(context = getFeaturedProductContext()) {
    const s = context?.querySelector('[data-subscription-step]');
    return Boolean(s && !s.classList.contains('hidden'));
}

/* === FLOATING CTA === */

function populateFloatingPlanSelect(context = getFeaturedProductContext()) {
    if (!context) return;
    const select = context.querySelector('[data-floating-plan-select]');
    if (!select) return;
    select.innerHTML = '';
    const currentPlan = getSelectedSellingPlanName(context);
    context.querySelectorAll('.nw-featured-product__plan-item:not(.hidden)').forEach(planItem => {
        const input = planItem.querySelector('.nw-featured-product__plan-item-input');
        const planName = (input?.value || '').trim();
        if (!planName) return;
        const titleEl = planItem.querySelector('.nw-featured-product__plan-item-header-title-text');
        const displayTitle = titleEl?.textContent?.trim() || planName;
        const discountEl = planItem.querySelector('[data-plan-discount-tag]');
        const saveText = discountEl?.textContent?.trim() || '';
        const label = saveText ? `${displayTitle} (${saveText})` : displayTitle;
        const option = document.createElement('option');
        option.value = planName;
        option.textContent = label;
        option.selected = planName.toLowerCase() === currentPlan.toLowerCase();
        select.appendChild(option);
    });
}

function updateFloatingCtaDisplay(context = getFeaturedProductContext()) {
    if (!context) return;
    const planName = getSelectedSellingPlanName(context);
    const planItem = getPlanItemFromContext(context, planName);
    const select = context.querySelector('[data-floating-plan-select]');
    if (select && planName) select.value = planName;
    const nameEl = context.querySelector('[data-floating-plan-name]');
    const tagEl = context.querySelector('[data-floating-plan-tag]');
    const priceEl = context.querySelector('[data-floating-plan-price]');
    const titleEl = planItem?.querySelector('.nw-featured-product__plan-item-header-title-text');
    const discountEl = planItem?.querySelector('[data-plan-discount-tag]');
    if (nameEl) nameEl.textContent = titleEl?.textContent?.trim() || planName;
    if (tagEl) tagEl.textContent = discountEl?.textContent?.trim() || '';
    if (priceEl) {
        const selections = getSelectedProductsWithQuantities(context);
        const ref = getPriceReferenceElement(context, selections);
        const planTotal = getPlanTotalCentsForSelections(selections, planName);
        const matchedPlan = getMatchedPlanFromSelections(selections, planName);
        const divisorOverride = planItem?.querySelector('[data-plan-per-month]')?.dataset?.perMonthDivisor;
        const periodDivisor = getPlanPeriodDivisor(matchedPlan, divisorOverride);
        const totalServingsPerDelivery = selections.reduce((t, s) => t + s.quantity * (parseInt(s.productData?.serving_size, 10) || 30), 0);
        const totalServingsOverPeriod = totalServingsPerDelivery * Math.max(periodDivisor, 1);
        if (totalServingsOverPeriod > 0 && planTotal > 0) {
            priceEl.textContent = `${formatMoney(planTotal / totalServingsOverPeriod, ref)} / serving`;
        } else {
            priceEl.textContent = '';
        }
    }
}

function showFloatingCta(context = getFeaturedProductContext()) {
    if (!context) return;
    const floatingCta = context.querySelector('[data-floating-cta]');
    if (!floatingCta) return;
    populateFloatingPlanSelect(context);
    updateFloatingCtaDisplay(context);
    floatingCta.classList.remove('hidden');
}

function hideFloatingCta(context = getFeaturedProductContext()) {
    if (!context) return;
    const floatingCta = context.querySelector('[data-floating-cta]');
    if (floatingCta) floatingCta.classList.add('hidden');
}

function scrollToPlanItem(context, planName) {
    if (window.innerWidth > 749) return;
    const planItem = getPlanItemFromContext(context, planName);
    if (!planItem) return;
    const top = planItem.getBoundingClientRect().top + window.pageYOffset - 84;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
}

function handleFloatingPlanSelectChange(event) {
    const context = getFeaturedProductContext(event.target);
    if (!context) return;
    const selectedPlanName = (event.target.value || '').trim();
    if (!selectedPlanName) return;
    const visibleInputs = [...context.querySelectorAll('.nw-featured-product__plan-item:not(.hidden) .nw-featured-product__plan-item-input')];
    const targetInput = visibleInputs.find(input => (input.value || '').trim().toLowerCase() === selectedPlanName.toLowerCase());
    if (targetInput) {
        targetInput.checked = true;
        updatePlanSelectionState(context);
        updatePlanPrices(context);
        updatePlanCtaPrice(context);
        updateFloatingCtaDisplay(context);
    }
    scrollToPlanItem(context, selectedPlanName);
}

/* === END FLOATING CTA === */

function goToStep2(context) {
    if (!context) return;
    const swatchesSection = context.querySelector('.nw-featured-product__swatches');
    const subscriptionStep = context.querySelector('[data-subscription-step]');
    if (swatchesSection) swatchesSection.classList.add('hidden');
    if (subscriptionStep) subscriptionStep.classList.remove('hidden');
    updateStepUI(context, 2);
    updatePlanVisibilityForMode(context);
    updatePlanSelectionState(context);
    showFloatingCta(context);
    updatePricingDisplay(context);
}

function isComboSwatchInput(input) { return Boolean(input?.closest('[data-combo-swatch-item]')); }

function restoreDefaultProductGallery(context = getFeaturedProductContext()) {
    const first = getFirstRegularSwatchInput(context);
    if (first) showSwatchGallery(first, context);
}

function getComboSwatchItemByProductId(context, productId) {
    if (!context || !productId) return null;
    const cb = context.querySelector(`[data-combo-swatch-item] ${SWATCH_INPUT_SELECTOR}[data-product-id="${productId}"]`);
    return cb?.closest('[data-combo-swatch-item]') || null;
}

function activateComboSelection(context, comboItem) {
    if (!context || !comboItem) return false;
    const cb = getSwatchInput(comboItem);
    const qi = comboItem.querySelector('[data-swatch-quantity-input]');
    resetSwatchQuantities(context);
    if (qi) qi.value = 1;
    updateSwatchActiveStates(context);
    if (cb) cb.checked = true;
    showSwatchGallery(cb, context);
    setPurchaseMode(context, 'combo');
    goToStep2(context);
    return true;
}

function selectComboProduct(context, productId) {
    return activateComboSelection(context, getComboSwatchItemByProductId(context, productId));
}

function handleComboProductClick(event) {
    event.preventDefault();
    const trigger = event.currentTarget;
    const comboUrl = (trigger.dataset.comboUrl || '').trim();
    if (comboUrl) { window.location.href = comboUrl; return; }
    const context = getFeaturedProductContext(trigger);
    activateComboSelection(context, context?.querySelector(`[data-combo-swatch-item][data-block-id="${trigger.dataset.blockId}"]`));
}

function initializeNWFeaturedProductSlider(context = document) {
    const scope = context.querySelector ? context : document;
    scope.querySelectorAll('.NWFeaturedProductSlider').forEach(mainEl => {
        if (swiperInstances.has(mainEl)) return;
        const sliderItem = mainEl.closest('.nw-featured-product__slider-item');
        const thumbsEl = sliderItem?.querySelector('.NWFeaturedProductSliderThumbs');
        let thumbsSwiper = null;
        if (thumbsEl && !thumbSwiperInstances.has(thumbsEl)) {
            thumbsSwiper = new Swiper(thumbsEl, { slidesPerView: 5, spaceBetween: 4, freeMode: false, watchSlidesProgress: true, breakpoints: { 750: { slidesPerView: 6, spaceBetween: 8 } } });
            thumbSwiperInstances.set(thumbsEl, thumbsSwiper);
        } else if (thumbsEl) { thumbsSwiper = thumbSwiperInstances.get(thumbsEl); }
        const mainSwiper = new Swiper(mainEl, { slidesPerView: 1, spaceBetween: 10, navigation: { nextEl: mainEl.querySelector('.swiper-button-next'), prevEl: mainEl.querySelector('.swiper-button-prev') }, thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined });
        swiperInstances.set(mainEl, mainSwiper);
    });
}

function showProductGallery(productId, context) {
    if (!context || !productId) return;
    const pid = String(productId);
    if (!context.querySelector(`.nw-featured-product__slider-item[data-product-id="${pid}"]`)) return;
    context.querySelectorAll('.nw-featured-product__slider-item').forEach(item => item.classList.toggle('hidden', item.dataset.productId !== pid));
    const visibleItem = context.querySelector(`.nw-featured-product__slider-item[data-product-id="${pid}"]`);
    const swiperEl = visibleItem?.querySelector('.NWFeaturedProductSlider');
    const thumbsEl = visibleItem?.querySelector('.NWFeaturedProductSliderThumbs');
    const swiper = swiperEl ? swiperInstances.get(swiperEl) : null;
    const thumbsSwiper = thumbsEl ? thumbSwiperInstances.get(thumbsEl) : null;
    if (thumbsSwiper) { thumbsSwiper.update(); thumbsSwiper.slideTo(0, 0); }
    if (swiper) { swiper.update(); swiper.slideTo(0, 0); }
}

function updateBackgroundImage(input) {
    const fp = document.querySelector('.nw-featured-product');
    if (!fp || !input) return;
    const di = input.dataset.desktopImage, mi = input.dataset.mobileImage;
    if (!di && !mi) return;
    fp.style.backgroundImage = `url(${(window.innerWidth <= 749 && mi) ? mi : (di || mi)})`;
}

function updateColorScheme(source) {
    const fp = document.querySelector('.nw-featured-product');
    if (!fp || !source) return;
    fp.classList.toggle('nw-featured-product--color-scheme-dark', (source.dataset.colorScheme || 'light') === 'dark');
}

function isSwatchQuantityControl(target) {
    return Boolean(target?.closest('[data-swatch-increase-trigger], [data-swatch-decrease-trigger], [data-swatch-quantity-input], .nw-featured-product__swatches-item-quantity-item'));
}

function updateActiveProductGallery(context = getFeaturedProductContext()) {
    if (!context) return;
    const sel = [...context.querySelectorAll('.nw-featured-product__swatches-item:not([data-combo-swatch-item])')].find(i => getSwatchQuantity(i) >= 1);
    if (sel) { showSwatchGallery(getSwatchInput(sel), context); return; }
    const first = getFirstRegularSwatchInput(context);
    if (first) { delete context.dataset.activeGalleryProductId; showSwatchGallery(first, context); }
}

function handleSwatchLabelClick(event) { if (isSwatchQuantityControl(event.target)) event.preventDefault(); }

function handleSwatchChange(input, options = {}) {
    if (isComboSwatchInput(input)) return;
    const context = getFeaturedProductContext(input);
    const swatchItem = input.closest('.nw-featured-product__swatches-item');
    const qi = swatchItem?.querySelector('[data-swatch-quantity-input]');
    const productId = input.dataset.productId;
    if (!productId || !context || !qi) return;
    if (input.checked) {
        if (!isComboSwatchInput(input)) { clearComboSelection(context); setPurchaseMode(context, 'multi'); }
        if (!options.skipQuantitySync && getSwatchQuantity(swatchItem) < 1) qi.value = 1;
        showSwatchGallery(input, context);
    } else { qi.value = 0; updateActiveProductGallery(context); }
    updatePricingDisplay(context);
    updateSwatchActiveStates(context);
}

function handleNavigatorClick(button) {
    const context = getFeaturedProductContext(button);
    const productId = button.dataset.productId;
    if (!productId || !context || isOnSubscriptionStep(context)) return;
    const matchingSwatch = getSwatchInputByProductId(context, productId);
    if (matchingSwatch) {
        const swatchItem = matchingSwatch.closest('.nw-featured-product__swatches-item');
        const already = matchingSwatch.checked && getSwatchQuantity(swatchItem) >= 1;
        if (already) { matchingSwatch.checked = false; handleSwatchChange(matchingSwatch); }
        else { matchingSwatch.checked = true; handleSwatchChange(matchingSwatch); }
        return;
    }
    showProductGallery(productId, context);
    updateColorScheme(button);
}

function getSelectedProductsWithQuantities(context = getFeaturedProductContext()) {
    if (!context) return [];
    const selections = [];
    context.querySelectorAll('.nw-featured-product__swatches-item').forEach(item => {
        const cb = getSwatchInput(item);
        const qi = item.querySelector('[data-swatch-quantity-input]');
        if (!cb || !qi) return;
        const qty = getSwatchQuantity(item);
        if (qty <= 0) return;
        selections.push({ productId: cb.dataset.productId, variantId: cb.dataset.variantId, quantity: qty, productData: getProductDataFromSwatchInput(cb) });
    });
    return selections;
}

function getSelectedSellingPlanName(context = getFeaturedProductContext()) {
    if (!context) return '';
    const visibleChecked = context.querySelector('.nw-featured-product__plan-item:not(.hidden) input[name="nw-featured-product-plan"]:checked');
    if (visibleChecked) return (visibleChecked.value || '').trim();
    const anyChecked = context.querySelector('input[name="nw-featured-product-plan"]:checked');
    return (anyChecked?.value || anyChecked?.dataset?.sellingPlanName || '').trim();
}

function updatePlanSelectionState(context = getFeaturedProductContext()) {
    if (!context) return;
    context.querySelectorAll('.nw-featured-product__plan-item').forEach(planItem => {
        const inp = planItem.querySelector('.nw-featured-product__plan-item-input');
        const isHidden = planItem.classList.contains('hidden');
        planItem.classList.toggle('is-selected', Boolean(inp?.checked) && !isHidden);
        if (!inp?.checked) {
            planItem.querySelector('[data-future-gifts-panel]')?.classList.add('hidden');
            const toggle = planItem.querySelector('[data-future-gifts-toggle]');
            if (toggle) toggle.setAttribute('aria-expanded', 'false');
        }
    });
}

function handlePlanSelectionChange(event) {
    const context = getFeaturedProductContext(event?.target);
    updatePlanSelectionState(context);
    updatePlanCtaPrice(context);
    updateFloatingCtaDisplay(context);
}

function handleFutureGiftsToggle(event) {
    event.preventDefault(); event.stopPropagation();
    const button = event.currentTarget;
    const planItem = button.closest('.nw-featured-product__plan-item');
    const panel = planItem?.querySelector('[data-future-gifts-panel]');
    if (!panel) return;
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    panel.classList.toggle('hidden', expanded);
    planItem?.classList.toggle('is-future-gifts-open', !expanded);
}

function formatMoney(cents, existingPriceElement) {
    const dollars = cents / 100;
    if (!existingPriceElement) return dollars.toFixed(2);
    const text = existingPriceElement.textContent.trim();
    if (!text) return dollars.toFixed(2);
    const m = text.match(/[\d,]+\.?\d*/);
    if (!m) return dollars.toFixed(2);
    const priceStr = m[0];
    const hasDecimals = priceStr.includes('.');
    const decimals = hasDecimals ? priceStr.split('.')[1]?.length || 0 : 0;
    let formatted = (hasDecimals && decimals > 0) ? dollars.toFixed(decimals) : (dollars % 1 === 0 ? dollars.toString() : dollars.toFixed(2));
    formatted = formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const before = text.substring(0, text.indexOf(priceStr));
    const after = text.substring(text.indexOf(priceStr) + priceStr.length);
    return `${before}${formatted}${after}`.trim();
}

function getOnetimeTotalCents(selections) {
    return selections.reduce((t, s) => t + (s.productData?.variant_price || 0) * s.quantity, 0);
}

function getPlanTotalCentsForSelections(selections, planName) {
    if (!planName || !selections?.length) return 0;
    return selections.reduce((t, s) => {
        const p = getSellingPlanFromProductDataByName(s.productData, planName);
        if (!p || p.price == null) return t;
        return t + p.price * s.quantity;
    }, 0);
}

function getPlanItemFromContext(context, planName) {
    if (!context || !planName) return null;
    const norm = planName.trim().toLowerCase();
    const inputs = [...context.querySelectorAll('input[name="nw-featured-product-plan"]')]
        .filter(i => (i.value || '').trim().toLowerCase() === norm);
    const visibleInp = inputs.find(i => !i.closest('.nw-featured-product__plan-item')?.classList.contains('hidden'));
    return (visibleInp || inputs[0])?.closest('.nw-featured-product__plan-item') || null;
}

function getPlanCompareTotalCentsForSelections(selections, planName, context = getFeaturedProductContext()) {
    if (!planName || !selections?.length) return 0;
    const matchedPlan = getMatchedPlanFromSelections(selections, planName);
    const planItem = getPlanItemFromContext(context, planName);
    const divisorOverride = planItem?.querySelector('[data-plan-per-month]')?.dataset?.perMonthDivisor;
    const periodDivisor = getPlanPeriodDivisor(matchedPlan, divisorOverride);
    return selections.reduce((t, s) => t + (s.productData?.variant_price || 0) * s.quantity * periodDivisor, 0);
}

function intervalPolicyToDays(interval, count = 1) {
    const n = String(interval || '').toUpperCase(), c = Number(count) || 1;
    if (n === 'DAY') return c; if (n === 'WEEK') return c * 7;
    if (n === 'MONTH') return c * 30; if (n === 'YEAR') return c * 365;
    return c;
}

function getMatchedPlanFromSelections(selections, planName) {
    if (!planName || !selections?.length) return null;
    for (const s of selections) { const p = getSellingPlanFromProductDataByName(s.productData, planName); if (p) return p; }
    return null;
}

function getPlanPeriodDivisor(plan, overrideDivisor) {
    const manual = Number(overrideDivisor);
    if (manual > 0) return manual;
    const bd = intervalPolicyToDays(plan?.billing_policy?.interval, plan?.billing_policy?.interval_count);
    const dd = intervalPolicyToDays(plan?.delivery_policy?.interval, plan?.delivery_policy?.interval_count);
    if (!bd || !dd) return 1;
    const d = bd / dd;
    return d >= 1 ? d : 1;
}

function getPerMonthCents(totalCents, divisor) {
    return Math.round(totalCents / (Number(divisor) > 0 ? Number(divisor) : 1));
}

function getPriceReferenceElement(context, selections = []) {
    if (selections.length) {
        const inp = getSwatchInputByProductId(context, selections[0].productId);
        const el = inp?.closest('.nw-featured-product__swatches-item')?.querySelector('[data-swatch-price-current]');
        if (el) return el;
    }
    return context.querySelector('[data-swatch-price-current]');
}

function getPlanBilledTemplate(planItem) {
    const s = planItem.querySelector('script[data-plan-billed-template]');
    if (!s) return ''; try { return JSON.parse(s.textContent) || ''; } catch { return ''; }
}

function applyBilledTemplate(template, price) { return template.split('{price}').join(price); }

function updatePlanPrices(context = getFeaturedProductContext()) {
    if (!context) return;
    const selections = getSelectedProductsWithQuantities(context);
    const ref = getPriceReferenceElement(context, selections);
    /*
     * totalQuantity: total bags selected across all SKUs.
     * Used to display price-per-bag correctly when multiple SKUs are selected.
     * Without this, selecting 2 bags shows the monthly TOTAL for 2 bags
     * rather than the per-bag price (which should be the same as selecting 1 bag).
     *
     * Formula: total / (periodDivisor × totalQuantity) = price per bag per delivery
     * e.g. 3-month plan, 2 bags: £168 / (3 × 2) = £28/bag ✓
     *      3-month plan, 1 bag:  £84  / (3 × 1) = £28/bag ✓
     */
    const totalQuantity = selections.reduce((t, s) => t + s.quantity, 0);
    context.querySelectorAll('.nw-featured-product__plan-item').forEach(planItem => {
        const inp = planItem.querySelector('.nw-featured-product__plan-item-input');
        const planName = (inp?.dataset?.sellingPlanName || inp?.value || '').trim();
        if (!selections.length || !planName) return;
        const total = getPlanTotalCentsForSelections(selections, planName);
        const matchedPlan = getMatchedPlanFromSelections(selections, planName);
        const divisor = getPlanPeriodDivisor(matchedPlan, planItem.querySelector('[data-plan-per-month]')?.dataset?.perMonthDivisor);
        const perMonthEl = planItem.querySelector('[data-plan-per-month]');
        if (perMonthEl) {
            const suffix = perMonthEl.dataset.perMonthSuffix || ' /mo';
            /* Multiply divisor by bag count to get true price per bag per delivery */
            const effectiveDivisor = divisor * Math.max(totalQuantity, 1);
            const priceStr = formatMoney(getPerMonthCents(total, effectiveDivisor), ref);
            perMonthEl.innerHTML = `${priceStr}<span class="nw-plan-per-month-suffix">${suffix}</span>`;
        }
        /* Billed text shows the TOTAL billing amount — correct as-is, no change needed */
        const billedEl = planItem.querySelector('[data-plan-billed-text]');
        const template = getPlanBilledTemplate(planItem);
        if (billedEl && template.includes('{price}')) billedEl.textContent = applyBilledTemplate(template, formatMoney(total, ref));
    });
}

function updatePlanCtaPrice(context = getFeaturedProductContext()) {
    if (!context) return;
    const wrap = context.querySelector('[data-plan-cta-prices]');
    if (!wrap) return;
    const compEl = wrap.querySelector('[data-plan-cta-compare-price]');
    const ctaEl = wrap.querySelector('[data-plan-cta-price]');
    const selections = getSelectedProductsWithQuantities(context);
    const planName = getSelectedSellingPlanName(context);
    const ref = getPriceReferenceElement(context, selections);
    if (!selections.length || !planName) { wrap.classList.add('hidden'); return; }
    const planTotal = getPlanTotalCentsForSelections(selections, planName);
    const compareTotal = getPlanCompareTotalCentsForSelections(selections, planName, context);
    if (ctaEl) ctaEl.textContent = formatMoney(planTotal, ref);
    if (compEl) {
        if (compareTotal > planTotal) { compEl.textContent = formatMoney(compareTotal, ref); compEl.classList.remove('hidden'); }
        else compEl.classList.add('hidden');
    }
    wrap.classList.remove('hidden');
}

function updatePricingDisplay(context = getFeaturedProductContext()) {
    updateOnetimeButtonPrice(context);
    updatePlanPrices(context);
    updatePlanCtaPrice(context);
    if (isOnSubscriptionStep(context)) updateFloatingCtaDisplay(context);
}

function updateOnetimeButtonPrice(context = getFeaturedProductContext()) {
    if (!context) return;
    const el = context.querySelector('[data-onetime-total-price]');
    if (!el) return;
    const sel = getSelectedProductsWithQuantities(context);
    if (!sel.length) { el.textContent = ''; return; }
    el.textContent = formatMoney(getOnetimeTotalCents(sel), getPriceReferenceElement(context, sel));
}

async function clearCart() {
    const r = await fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } });
    if (!r.ok) throw new Error('Unable to clear cart');
    return r.json();
}

function getCartSectionIds() {
    const ids = [];
    document.querySelectorAll('cart-items-component').forEach(i => { if (i instanceof HTMLElement && i.dataset.sectionId) ids.push(i.dataset.sectionId); });
    return ids;
}

function getCartItemCount(items) { return items.reduce((t, i) => t + (parseInt(i.quantity, 10) || 0), 0); }
function redirectToCheckout() { document.body.removeAttribute('data-scroll-locked'); window.location.href = '/checkout'; }
function dispatchFeaturedProductCartUpdate({ itemCount, sections } = {}) {
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: {}, sourceId: '', data: { source: 'nw-featured-product-v3', itemCount: itemCount || 0, sections: sections || {} } } }));
}

async function handleOnetimeAddToCart(event) {
    event.preventDefault();
    const context = getFeaturedProductContext(event.currentTarget);
    const button = event.currentTarget;
    const buttonAction = button.dataset.buttonAction || 'cart_drawer';
    const selections = getSelectedProductsWithQuantities(context);
    if (!selections.length) return;
    const items = selections.map(s => ({ id: parseInt(s.variantId, 10), quantity: s.quantity }));
    button.disabled = true;
    const isCheckout = buttonAction === 'checkout';
    if (isCheckout) document.body.classList.add('disabled-recharge-cart-drawer');
    try {
        await clearCart();
        const body = { items };
        /* Performance: only request cart-drawer section re-renders when we will
           actually show the drawer. On the checkout path we redirect immediately
           and never use the rendered sections, so requesting them just adds
           server render time between the click and the checkout redirect. */
        if (!isCheckout) { const ids = getCartSectionIds(); if (ids.length) body.sections = ids.join(','); }
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        const data = await r.json();
        if (data.status) { if (isCheckout) document.body.classList.remove('disabled-recharge-cart-drawer'); return; }
        if (isCheckout) { redirectToCheckout(); return; }
        dispatchFeaturedProductCartUpdate({ itemCount: getCartItemCount(items), sections: data.sections || {} });
    } catch { if (isCheckout) document.body.classList.remove('disabled-recharge-cart-drawer'); }
    finally { button.disabled = false; }
}

async function handlePlanAddToCart(event) {
    event.preventDefault();
    const context = getFeaturedProductContext(event.currentTarget);
    const button = event.currentTarget;
    const buttonAction = button.dataset.buttonAction || 'checkout';
    const selections = getSelectedProductsWithQuantities(context);
    const planName = getSellingPlanNameForCart(context);
    if (!selections.length || !planName) return;
    const bundleId = window.NWWelcomeKitCart?.createBundleId?.() || `nw-${Date.now()}`;
    const items = selections.map(s => {
        const p = getSellingPlanFromProductDataByName(s.productData, planName);
        if (!p?.id) return null;
        return { id: parseInt(s.variantId, 10), quantity: s.quantity, selling_plan: parseInt(p.id, 10), properties: { _bundle_id: bundleId, _line_type: window.NWWelcomeKitCart?.LINE_TYPE_SUBSCRIPTION || 'subscription' } };
    }).filter(Boolean);
    if (items.length !== selections.length) { console.error('Plan match failed:', planName); return; }
    const kitItems = getWelcomeKitCartItems(context).map(i => ({ ...i, properties: { _bundle_id: bundleId, _line_type: window.NWWelcomeKitCart?.LINE_TYPE_WELCOME_KIT || 'welcome_kit' } }));
    const cartItems = [...items, ...kitItems];
    button.disabled = true;
    const isCheckout = buttonAction === 'checkout';
    if (isCheckout) document.body.classList.add('disabled-recharge-cart-drawer');
    try {
        await clearCart();
        const body = { items: cartItems };
        /* Performance: skip cart-drawer section re-render on the checkout path
           (rendered sections are unused before the redirect). */
        if (!isCheckout) { const ids = getCartSectionIds(); if (ids.length) body.sections = ids.join(','); }
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        const data = await r.json();
        if (data.status) { if (isCheckout) document.body.classList.remove('disabled-recharge-cart-drawer'); return; }
        await window.NWWelcomeKitCart?.validate?.();
        if (isCheckout) { redirectToCheckout(); return; }
        dispatchFeaturedProductCartUpdate({ itemCount: getCartItemCount(cartItems), sections: data.sections || {} });
    } catch { if (isCheckout) document.body.classList.remove('disabled-recharge-cart-drawer'); }
    finally { button.disabled = false; }
}

function initializePlanBlocks(context = document) {
    const scope = context.querySelector ? context : document;
    scope.querySelectorAll('input[name="nw-featured-product-plan"]').forEach(i => i.addEventListener('change', handlePlanSelectionChange));
    scope.querySelectorAll('[data-future-gifts-toggle]').forEach(b => b.addEventListener('click', handleFutureGiftsToggle));
    scope.querySelectorAll('[data-plan-add-to-cart], [data-floating-plan-add-to-cart]').forEach(b => b.addEventListener('click', handlePlanAddToCart));
    scope.querySelectorAll('[data-onetime-add-to-cart]').forEach(b => b.addEventListener('click', handleOnetimeAddToCart));
    scope.querySelectorAll('[data-floating-plan-select]').forEach(s => s.addEventListener('change', handleFloatingPlanSelectChange));
    const fp = scope.querySelector?.('.nw-featured-product') || getFeaturedProductContext(scope);
    if (fp) { updatePlanSelectionState(fp); updatePricingDisplay(fp); }
}

function updateStepUI(context, step) {
    const hdr = context?.querySelector('[data-step-header]');
    if (!hdr) return;
    const progress = hdr.querySelector('[data-step-progress]');
    const count = hdr.querySelector('[data-step-count]');
    const backBtn = hdr.querySelector('.nw-featured-product__swatches-title-back-button');
    /* Single-product mode: no Step 1 exists, so suppress the step counter,
       progress bar and back button, and always show the Step 2 (plan) title. */
    if (isSingleProductMode(context)) {
        const progressWrap = hdr.querySelector('.nw-featured-product__swatches-title-step-progress');
        if (progressWrap) progressWrap.classList.add('hidden');
        if (count) count.classList.add('hidden');
        if (backBtn) backBtn.classList.add('hidden');
        hdr.querySelectorAll('[data-step-title]').forEach(el => el.classList.toggle('hidden', parseInt(el.dataset.stepTitle, 10) !== 2));
        return;
    }
    if (progress) progress.style.setProperty('--progress-width', `${(step / 2) * 100}%`);
    if (count) count.textContent = `${step} of 2`;
    if (backBtn) backBtn.classList.toggle('hidden', step === 1);
    hdr.querySelectorAll('[data-step-title]').forEach(el => el.classList.toggle('hidden', parseInt(el.dataset.stepTitle, 10) !== step));
}

function handleNextButtonClick(event) {
    const context = getFeaturedProductContext(event?.currentTarget);
    if (!getSelectedProductsWithQuantities(context).length) return;
    setPurchaseMode(context, 'multi');
    goToStep2(context);
}

function handleBackButtonClick(event) {
    const context = getFeaturedProductContext(event?.currentTarget);
    /* No Step 1 to return to in single-product mode. */
    if (isSingleProductMode(context)) return;
    const wasCombo = isComboPurchaseMode(context);
    const swatchesSection = context.querySelector('.nw-featured-product__swatches');
    const subscriptionStep = context.querySelector('[data-subscription-step]');
    if (swatchesSection) swatchesSection.classList.remove('hidden');
    if (subscriptionStep) subscriptionStep.classList.add('hidden');
    hideFloatingCta(context);
    setPurchaseMode(context, 'multi');
    if (wasCombo) { clearComboSelection(context); restoreDefaultProductGallery(context); updateSwatchActiveStates(context); updatePricingDisplay(context); }
    updatePlanVisibilityForMode(context);
    updateStepUI(context, 1);
}

function handleProductSwatchTrigger(event) {
    event.preventDefault();
    const trigger = event.currentTarget;
    const activeSwatchItem = trigger.closest('[data-swatch-item]') || document.querySelector('[data-swatch-item].active');
    if (!activeSwatchItem) return;
    const productId = activeSwatchItem.getAttribute('data-product-id');
    if (!productId) return;
    const targetEl = document.getElementById('nw-featured-product');
    const context = targetEl?.closest('.nw-featured-product') || getFeaturedProductContext();
    const comboUrl = (trigger.dataset.comboUrl || '').trim();
    if (comboUrl) { window.location.href = comboUrl; return; }
    const ok = Boolean(getComboSwatchItemByProductId(context, productId))
        ? selectComboProduct(context, productId)
        : selectSingleSwatchProduct(context, productId);
    if (!ok || !targetEl) return;
    const isMobile = window.innerWidth <= 749;
    window.scrollTo({ top: isMobile ? targetEl.getBoundingClientRect().bottom + window.pageYOffset - window.innerHeight - 40 : targetEl.getBoundingClientRect().top + window.pageYOffset - 65, behavior: 'smooth' });
}

function selectSwatchFromQuantityElement(element) {
    const swatchItem = element.closest('.nw-featured-product__swatches-item');
    const cb = getSwatchInput(swatchItem);
    if (!cb) return;
    if (!cb.checked) { cb.checked = true; handleSwatchChange(cb, { skipQuantitySync: true }); return; }
    showSwatchGallery(cb, getFeaturedProductContext(element));
}

function handleSwatchQuantityIncrease(button, event) {
    event.preventDefault(); event.stopPropagation();
    const input = button.closest('.nw-featured-product__swatches-item-quantity-item')?.querySelector('[data-swatch-quantity-input]');
    if (!input) return;
    selectSwatchFromQuantityElement(button);
    const cur = parseInt(input.value, 10) || 0;
    const max = parseInt(input.max, 10);
    input.value = isNaN(max) ? cur + 1 : Math.min(cur + 1, max);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    const context = getFeaturedProductContext(button);
    if (!button.closest('[data-combo-swatch-item]')) { clearComboSelection(context); setPurchaseMode(context, 'multi'); }
    updatePricingDisplay(context);
    updateSwatchActiveStates(context);
}

function handleSwatchQuantityDecrease(button, event) {
    event.preventDefault(); event.stopPropagation();
    const input = button.closest('.nw-featured-product__swatches-item-quantity-item')?.querySelector('[data-swatch-quantity-input]');
    if (!input) return;
    selectSwatchFromQuantityElement(button);
    const cur = parseInt(input.value, 10) || 0;
    input.value = Math.max(cur - 1, parseInt(input.min, 10) || 0);
    const cb = getSwatchInput(button.closest('.nw-featured-product__swatches-item'));
    const context = getFeaturedProductContext(button);
    if (parseInt(input.value, 10) === 0 && cb) cb.checked = false;
    if (!button.closest('[data-combo-swatch-item]')) setPurchaseMode(context, 'multi');
    updatePricingDisplay(context);
    updateSwatchActiveStates(context);
}

function initializeSwatchQuantitySelectors(context = document) {
    const scope = context.querySelector ? context : document;
    scope.querySelectorAll('[data-swatch-increase-trigger]').forEach(b => b.addEventListener('click', e => handleSwatchQuantityIncrease(b, e)));
    scope.querySelectorAll('[data-swatch-decrease-trigger]').forEach(b => b.addEventListener('click', e => handleSwatchQuantityDecrease(b, e)));
    scope.querySelectorAll('[data-swatch-quantity-input]').forEach(input => {
        input.addEventListener('focus', () => selectSwatchFromQuantityElement(input));
        input.addEventListener('click', e => { e.stopPropagation(); selectSwatchFromQuantityElement(input); });
    });
    scope.querySelectorAll('.nw-featured-product__swatches-item-quantity-item').forEach(qi => {
        qi.addEventListener('mousedown', e => { if (e.target.closest('[data-swatch-increase-trigger], [data-swatch-decrease-trigger], [data-swatch-quantity-input]')) selectSwatchFromQuantityElement(qi); });
    });
}

function initializeSliderNavigator(context = document) {
    const scope = context.querySelector ? context : document;
    scope.querySelectorAll('.nw-featured-product__slider-navigator-item-button').forEach(b => b.addEventListener('click', () => handleNavigatorClick(b)));
}

function initializeSwatchPreview(context = getFeaturedProductContext()) {
    if (!context) return;
    const firstInput = getFirstRegularSwatchInput(context);
    if (firstInput) {
        const swatchItem = firstInput.closest('.nw-featured-product__swatches-item');
        const qtyInput = swatchItem?.querySelector('[data-swatch-quantity-input]');
        firstInput.checked = true;
        if (qtyInput) qtyInput.value = 1;
        showSwatchGallery(firstInput, context);
    }
    updateSwatchActiveStates(context);
}

function initializeSwatches(context = document) {
    const scope = context.querySelector ? context : document;
    scope.querySelectorAll(SWATCH_INPUT_SELECTOR).forEach(input => input.addEventListener('change', () => handleSwatchChange(input)));
    scope.querySelectorAll('.nw-featured-product__swatches-item:not([data-combo-swatch-item]) label[for^="nw-featured-product-swatches-"]').forEach(label => label.addEventListener('click', handleSwatchLabelClick));
    initializeSliderNavigator(scope);
    initializeSwatchQuantitySelectors(scope);
    const nextBtn = scope.querySelector('[data-next-trigger]');
    if (nextBtn) nextBtn.addEventListener('click', handleNextButtonClick);
    scope.querySelectorAll('[data-back-trigger]').forEach(b => b.addEventListener('click', handleBackButtonClick));
    scope.querySelectorAll('[data-combo-trigger]').forEach(b => b.addEventListener('click', handleComboProductClick));
    const fp = scope.querySelector?.('.nw-featured-product') || getFeaturedProductContext(scope);
    if (fp) {
        updateStepUI(fp, 1);
        initializeSwatchPreview(fp);
        /* Single-SKU buy box (e.g. Athletic landing page or a product page): the
           one product is already selected by initializeSwatchPreview, so skip
           the redundant Step 1 and open directly at Step 2 (plans). */
        if (isSingleProductMode(fp)) { setPurchaseMode(fp, 'multi'); goToStep2(fp); }
    }
    scope.querySelectorAll('[data-product-swatch-trigger]').forEach(b => b.addEventListener('click', handleProductSwatchTrigger));
}

let resizeTimer;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
        const ai = getActiveGalleryInput(getFeaturedProductContext());
        if (ai) updateBackgroundImage(ai);
    }, 250);
});

document.addEventListener('DOMContentLoaded', () => {
    initializeNWFeaturedProductSlider(document);
    initializeSwatches(document);
    initializePlanBlocks(document);
});

document.addEventListener('shopify:section:load', event => {
    if (event.target.querySelector('.NWFeaturedProductSlider')) {
        initializeNWFeaturedProductSlider(event.target);
        initializeSwatches(event.target);
        initializePlanBlocks(event.target);
    }
});
